export default "/images/6d6994ecfdd85bb4f386ea73aad2560a.avif";